/* global google */
import React from "react";
import { Map, Marker, GoogleApiWrapper } from "google-maps-react";
import PlacesAutocomplete from "react-places-autocomplete";
import locationMarker from "../assets/images/map-marker.png";
import { RotateRightSharp } from "@material-ui/icons";
import locationIcon from "../assets/images/map-marker.svg";

class LocationSearchInput extends React.Component {
  constructor(props) {
    console.log(props);
    super(props);
    this.state = { address: props.value || "" };
    this.placesService = new window.google.maps.places.PlacesService(
      document.createElement("div")
    );
    this.handleChange = this.handleChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    console.log(prevProps);
    console.log("did");
    console.log(prevState);
    console.log(this.props.value);
    // if(!this.props.value){
    //   this.setState({ address : prevState.address || ""  });
    // }
    // only update chart if the data has changed
    if (prevProps.value !== this.props.value) {
      this.setState({ address: this.props.value || prevProps.value });
    }
  }

  componentWillUpdate(nextProps, nextState) {
    console.log(nextProps);
    console.log(nextState);

    // this.setState({ address :nextProps.value || ""  });

    //this.handleChange({ address :nextProps.value || ""  })
    // if (nextState.open == true && this.state.open == false) {
    //   this.props.onWillOpen();
    // }
  }
  handleChange = (address) => {
    this.setState({ address });
  };

  handleSelect = (address, placeId) => {
    this.setState({ address });

    const request = {
      placeId: placeId,
      fields: ["name", "geometry"],
    };
    this.placesService.getDetails(request, (place, status) => {
      if (status == google.maps.places.PlacesServiceStatus.OK) {
        this.props.onPlaceChanged(place);
      }
    });
  };

  render() {
    return (
      <PlacesAutocomplete
        value={this.state.address}
        onChange={this.handleChange}
        onSelect={this.handleSelect}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div
            className="autocomplete-container"
            style={{ position: "relative" }}
          >
            <input
              {...getInputProps({
                placeholder: "Search Places ...",
                className: "location-search-input",
              })}
              style={{
                width: "100%",
                border: "1px solid #ddd",
                height: "32px",
                outline: "0",
                padding: "5px 10px",
                boxSizing: "border-box",
              }}
            />
            <div
              className="autocomplete-dropdown-container"
              style={{
                border: "1px solid #e2e2e2",
                position: "absolute",
                zIndex: "99999999",
                width: "100%",
                borderTop: "0px",
                boxSizing: "border-box",
              }}
            >
              {loading && <div></div>}
              {suggestions.map((suggestion, i) => {
                const className = suggestion.active
                  ? "suggestion-item--active"
                  : "suggestion-item";
                console.log("i==" + i);
                // inline style for demonstration purpose
                const style = suggestion.active
                  ? {
                      backgroundColor: "#fafafa",
                      cursor: "pointer",
                      borderBottom: "1px solid #e2e2e2",
                      padding: "5px",
                      fontSize: "13px",
                      display: "flex",
                    }
                  : {
                      backgroundColor: "#ffffff",
                      cursor: "pointer",
                      borderBottom: "1px solid #e2e2e2",
                      padding: "5px",
                      fontSize: "13px",
                      display: "flex",
                    };
                return (
                  <div
                    key={i}
                    {...getSuggestionItemProps(suggestion, {
                      className,
                      style,
                    })}
                  >
                    <img
                      src={locationMarker}
                      alt=""
                      style={{
                        width: "20px",
                        opacity: "0.6",
                        paddingRight: "5px",
                        verticalAlign: "text-top",
                      }}
                    />
                    <span
                      style={{
                        width: "90%",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {suggestion.description}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
    );
  }
}

class MapContainer extends React.Component {
  constructor(props) {
    console.log(props);
    super(props);
    this.state = {
      address: props.address || "",
      places: [],
      markers: [],
      marker: "https://www.saasotest.tk/app/admin/assets/images/map-marker.svg",
      city: "",
      state: "",
      country: "",
      zipcode: "",
      area: "",
    };
    this.showPlace = this.showPlace.bind(this);
    this.mapRef = React.createRef();
    this.geocoder = new google.maps.Geocoder();
  }

  getCity = (addressArray) => {
    let city = "";
    for (let i = 0; i < addressArray.length; i++) {
      if (
        addressArray[i].types[0] &&
        "administrative_area_level_2" === addressArray[i].types[0]
      ) {
        city = addressArray[i].long_name;
        return city;
      }
    }
  };

  getArea = (addressArray) => {
    let area = "";
    for (let i = 0; i < addressArray.length; i++) {
      if (addressArray[i].types[0]) {
        for (let j = 0; j < addressArray[i].types.length; j++) {
          if (
            "sublocality_level_1" === addressArray[i].types[j] ||
            "locality" === addressArray[i].types[j]
          ) {
            area = addressArray[i].long_name;
            return area;
          }
        }
      }
    }
  };
  getState = (addressArray) => {
    let state = "";
    for (let i = 0; i < addressArray.length; i++) {
      for (let i = 0; i < addressArray.length; i++) {
        if (
          addressArray[i].types[0] &&
          "administrative_area_level_1" === addressArray[i].types[0]
        ) {
          state = addressArray[i].long_name;
          return state;
        }
      }
    }
  };

  getCountry = (addressArray) => {
    let country = "";
    for (let i = 0; i < addressArray.length; i++) {
      if (addressArray[i].types[0] && "country" === addressArray[i].types[0]) {
        country = addressArray[i].long_name;
        return country;
      }
    }
  };

  getZipcode = (addressArray) => {
    let zipcode = "";
    for (let i = 0; i < addressArray.length; i++) {
      if (
        addressArray[i].types[0] &&
        "postal_code" === addressArray[i].types[0]
      ) {
        zipcode = addressArray[i].long_name;
        return zipcode;
      }
    }
  };

  showPlace(place) {
    this.setState((prevState) => ({
      places: [place],
      markers: [],
      marker: "",
    }));

    console.log("places" + JSON.stringify(this.state.places));
    console.log(place.geometry.location);
    this.mapRef.current.map.setCenter(place.geometry.location);
    this.geocodeAddress(this.state.places, place.geometry.location);
  }

  onMarkerDragEnd = (coord, index) => {
    console.log(coord);
    const { latLng } = coord;
    const lat = latLng.lat();
    const lng = latLng.lng();
    console.log(lat);
    this.setState((prevState) => ({
      markers: [{ position: { lat, lng } }],
      places: [],
    }));
    // console.log("places2" + this.showPlace());
    this.geocodeAddress(coord, latLng);

    // this.setState(prevState => {
    //   // const markers = [...this.state.markers];
    //   markers = [{position: { lat, lng } }];
    //   console.log(markers)
    //   return { markers };
    // });
  };

  geocodeAddress(address, latlng) {
    var latlngNew = {
      lat: parseFloat(latlng.lat()),
      lng: parseFloat(latlng.lng()),
    };
    console.log(latlngNew);
    this.geocoder.geocode(
      { location: latlngNew },
      function handleResults(results, status) {
        console.log(results[0]);
        console.log(results[0].address_components);
        var addressArray = results[0].address_components;
        var city = this.getCity(addressArray);
        var area = this.getArea(addressArray);
        var state = this.getState(addressArray);
        var country = this.getCountry(addressArray);
        var zipcode = this.getZipcode(addressArray);

        var adreessComponents = {
          address: address[0]?.name || results[0].formatted_address,
          area: area ? area : "",
          city: city ? city : "",
          state: state ? state : "",
          country: country ? country : "",
          zipcode: zipcode ? zipcode : "",
        };
        this.setState(adreessComponents);

        console.log(adreessComponents);

        // this.setState({address : adreessComponents.address})
        this.props.onChange(adreessComponents, latlng, results[0]);

        if (status === google.maps.GeocoderStatus.OK) {
          console.log(status);
          this.mapRef.current.map.setCenter(results[0].geometry.location);
          // this.mapRef.current.map.setPosition(results[0].geometry.location);

          return;
        }

        // this.mapRef.setCenter({
        //   lat: ATLANTIC_OCEAN.latitude,
        //   lng: ATLANTIC_OCEAN.longitude,
        // });

        // this.marker.setPosition({
        //   lat: ATLANTIC_OCEAN.latitude,
        //   lng: ATLANTIC_OCEAN.longitude,
        // });
      }.bind(this)
    );
  }

  render() {
    return (
      <div
        className="map-container"
        key={this.props.type}
        style={{ padding: this.props.padding === true ? "4px 15px" : "" }}
      >
        {this.props.label ? <label>{this.props.label}</label> : ""}
        {this.props.search === true ? (
          <LocationSearchInput
            onPlaceChanged={this.showPlace}
            value={this.state.address}
          />
        ) : (
          ""
        )}
        <Map
          ref={this.mapRef}
          google={this.props.google}
          className={"map"}
          zoom={16}
          initialCenter={this.props.centerLocation}
          mapTypeControl={false}
          streetViewControl={false}
          zoomControl={false}
          fullscreenControl={false}
          style={{
            height: this.props.height,
            minHeight: "200px",
            position: "relative",
          }}
        >
          {this.state.places && this.state.places.length > 0 ? (
            this.state.places.map((place, i) => {
              return (
                <Marker
                  key={i}
                  draggable={this.props.moveMarker}
                  visible={true}
                  position={place.geometry.location}
                  icon={{
                    url: locationIcon,
                    anchor: new google.maps.Point(32, 32),
                    scaledSize: new google.maps.Size(40, 40),
                  }}
                  onDragend={(t, map, coord) => this.onMarkerDragEnd(coord, i)}
                />
              );
            })
          ) : this.state.markers && this.state.markers.length > 0 ? (
            this.state.markers.map((marker, index) => (
              <Marker
                key={index}
                position={marker.position}
                visible={true}
                draggable={this.props.moveMarker}
                onDragend={(t, map, coord) =>
                  this.onMarkerDragEnd(coord, index)
                }
                icon={{
                  url: locationIcon,
                  anchor: new google.maps.Point(32, 32),
                  scaledSize: new google.maps.Size(40, 40),
                }}
              />
            ))
          ) : (
            <Marker
              draggable={this.props.moveMarker}
              visible={true}
              position={this.props.centerLocation}
              icon={{
                url: locationIcon,
                anchor: new google.maps.Point(32, 32),
                scaledSize: new google.maps.Size(40, 40),
              }}
              onDragend={(t, map, coord) => this.onMarkerDragEnd(coord)}
            />
          )}
        </Map>
      </div>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: process.env.REACT_APP_GOOGLE_KEY,
  libraries: ["places"],
})(MapContainer);
